define(['text!./templates/lob-selection.html', 'underscore'],
    (templateStr, _)=> {
        return [()=> {

/*    CHG0031104 - Add OMEGA QnB link to SECU’s website
    AB - April 05, 2020 */

            var urlString = window.location.search.substring(1) // Extract argument string from url
            var argArray = urlString.split('&');                // build array of url arugemnts
            var argKeyValuePair = argArray[0].split('=');       // pick the first row from argArray (Source)
            var qnbSource = argKeyValuePair[1]                  // pick the 2nd element
            return {
                scope: {
                    model: '=gwLobSelection',
                    form: '='
                },
                template: templateStr,
                controller: ['$scope', 'lobConfig', ($scope, lobConfig) => {
                    const lobMap = {'PersonalAuto': 'pa', 'Homeowners': 'ho'};

                    $scope.moreThanOneLob = false;
                    $scope.moreThanOneLob = lobConfig.lobs.length > 1;
                    if (qnbSource == "SECU"){
                        $scope.moreThanOneLob = false;
                    }
                    $scope.selectLob = (lob)=> {
                        if (_.contains(lobConfig.lobs, lobMap[lob])) {
                            $scope.model.productCode.value = lob;
                        }
                    };
                }]
            };
        }];
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/directives/LobSelection.js
 **/